import type { AddFundDividendCommandData } from '@festina/unitlink-general-types/unitlink'
import { typeUtils } from '@festina-life/core'
import { FormikForm, FormikTextInput } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import type { CommandPaletteFormProps } from '../../commandActions/commandPalette/CommandPaletteModalButton'
import { FundDividendFields } from './FundDividendFields'

const validateKey = typeUtils.createValidator<AddFundDividendCommandData>()

export const AddFundDividendForm = (
  props: CommandPaletteFormProps<AddFundDividendCommandData>,
) => {
  const translate = useTranslate()

  const { isinKey } = useHook('routing.general.useFundPricesParams')()
  const initialValues: AddFundDividendCommandData = {
    _type: 'AddFundDividendCommandData',
    isinKey,
    fundDividend: {
      _type: 'FundDividend',
    },
  }

  return (
    <FormikForm initialValues={initialValues} {...props}>
      <FormikTextInput
        name={validateKey('isinKey')}
        label={translate('funds.fundItem.isinKey')}
      />
      <FundDividendFields fieldNamePrefix={validateKey('fundDividend')} />
    </FormikForm>
  )
}
